import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#5a2e8d',
        secondary: '#26DA4A',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
});
